import { FormInstance, Typography } from 'antd';
import moment from 'moment';
import React, { useState } from 'react';
import { ExtraTableResize } from '../../common/compornents/extraTableResize';
import TableComponent from '../../common/compornents/TableComponent';
import { Const } from '../../common/constants/Constants';
import { JuchuData } from '../../common/objectType/JuchuData';
import { JuchuDetailData } from '../../common/objectType/JuchuDetailData';
import { Session } from '../../common/objectType/Session';
import JuchuNyuryokuDetailEdit from './JuchuNyuryokuDetailEdit';

interface IProps {
  session: Session;
  juchuData: JuchuData;
  juchuListlData: any[];
  updateJuchuListData: (data: any[]) => void;
  juchuDetailData: JuchuDetailData;
  updateJuchuDetailData: (data: any) => void;
  dispJuchuDetailData: JuchuDetailData;
  updateDispJuchuDetailData: (data: any) => void;
  juchuListDelData: any[];
  updateJuchuListDelData: (data: any[]) => void;
  headerForm: FormInstance;
  detailForm: FormInstance;
  shoriSentaku: string;
  nonyuSaki?: number;
  clearFlg: boolean;
  updateClearFlg: (data: any) => void;
  loading: boolean;
  changeLoading: (data: any) => void;
}

// 一覧ヘッダー情報
const columnInit: any = [
  {
    title: 'No.',
    dataIndex: 'dispNo',
    width: 50,
    align: 'center',
    // fixed: 'left',
  },
  {
    title: '製品名',
    dataIndex: 'hinNm',
    width: 320,
    align: 'left',
    ellipsis: true,
  },
  {
    title: '規格',
    dataIndex: 'kikaku',
    width: 600,
    align: 'left',
    ellipsis: true,
    className: 'text-wrap', // 空白を表示するスタイル
    // eslint-disable-next-line react/display-name
    render: (_: any, record: any) => {
      return (
        <div>
          {(record['irime'] || '') +
            (record['irimeNm'] || '') +
            ' ' +
            (record['tuyaNm'] || '') +
            ' ' +
            (record['hinSizeNm'] || '') +
            ' ' +
            (record['hinShapeNm'] || '') +
            ' ' +
            (record['hinJointNm'] || '')}
        </div>
      );
    },
  },
  {
    title: '色調',
    dataIndex: 'hyoujiIroCd',
    width: 180,
    align: 'left',
    ellipsis: true,
  },
  {
    title: '基本色調',
    dataIndex: 'kihonIroCd',
    width: 180,
    align: 'left',
    ellipsis: true,
  },
  {
    title: '数量',
    dataIndex: 'jyuSu',
    width: 100,
    ellipsis: true,
    align: 'right',
    // className: 'clsQuantity',
    // eslint-disable-next-line react/display-name
    render: (_: any, record: any) => {
      if (record['inzu'] !== null && record['inzu'] !== '' && record['inzu'] !== undefined) {
        let suryo: number = record['jyuSu'];
        let inzu: number = record['inzu'];
        return <div>{(suryo * inzu || '') + (record['nisugataNm'] || '')}</div>;
      } else {
        return <div>{(record['jyuSu'] || '') + (record['nisugataNm'] || '')}</div>;
      }
    },
  },
  {
    title: '回答納期',
    dataIndex: 'kaitoDt',
    width: 130,
    ellipsis: true,
    align: 'left',
    // className: 'clsAnswerDeliveryDate',
    // eslint-disable-next-line react/display-name
    render: (_: any, record: any) => {
      if (Boolean(record.kaitoDt) !== false)
        return (
          <div>
            {moment(record['kaitoDt']).format('YYYY/MM/DD') + ' ' + (record['ampmNm'] || '')}
          </div>
        );
    },
  },
  {
    title: '状況',
    dataIndex: 'kaitoNm',
    width: 70,
    ellipsis: true,
    align: 'left',
  },
  {
    title: '運送便',
    dataIndex: 'haiNm',
    width: 200,
    ellipsis: true,
    align: 'left',
    render: (_: any, record: any) => {
      return <div>{(record['haiNm'] || '') + (record['haiShitenNm'] || '')}</div>;
    },
  },
  {
    title: '送り状No.',
    dataIndex: 'okuriNoLink',
    width: 170,
    ellipsis: true,
    align: 'left',
    // eslint-disable-next-line react/display-name
    render: (_: any, record: any) => {
      if (record.haiUrlMae !== undefined && record.haiUrlMae !== null && record.haiUrlMae !== '') {
        let strUrl = (record['haiUrlMae'] || '') + (record['okuriNo'] || '');
        if (
          record.haiUrlAto !== undefined &&
          record.haiUrlAto !== null &&
          record.haiUrlAto !== ''
        ) {
          strUrl = strUrl + (record['haiUrlAto'] || '');
        }
        return (
          <Typography.Link
            // href={
            //   (record['haiUrlMae'] || '') + (record['okuriNo'] || '') + (record['haiUrlAto'] || '')
            // }
            href={strUrl}
            target="_blank"
          >
            <div>{record['okuriNo'] || ''}</div>
          </Typography.Link>
        );
      } else {
        return <div>{record['okuriNo'] || ''}</div>;
      }
    },
  },
  {
    title: '出荷日',
    dataIndex: 'syukkaDt',
    width: 100,
    ellipsis: true,
    // className: 'clsShipDate',
    align: 'left',
    // eslint-disable-next-line react/display-name
    render: (_: any, record: any) => {
      if (Boolean(record.syukkaDt) !== false)
        return moment(record['syukkaDt']).format('YYYY/MM/DD');
    },
  },
  {
    title: '製品コード',
    dataIndex: 'hinCd',
    width: 150,
    ellipsis: true,
    align: 'left',
  },
  {
    title: '見本板No.',
    dataIndex: 'mihonNo',
    width: 120,
    ellipsis: true,
    align: 'left',
  },
];

const JuchuNyuryokuDetail: React.FC<IProps> = (props: IProps) => {
  const [columns, changeColumns] = useState(columnInit);
  const [rIdx, changeRowIndex] = useState(-1);

  const doubleClick = (record: JuchuDetailData) => {
    if (
      props.shoriSentaku === Const.SHORI_KBN.Create ||
      props.shoriSentaku === Const.SHORI_KBN.Edit
    ) {
      props.updateDispJuchuDetailData(record);
      props.updateJuchuDetailData(record);
    }
  };

  return (
    <>
      <div style={{ backgroundColor: '#e6f7ff' }}>
        <JuchuNyuryokuDetailEdit
          session={props.session}
          juchuData={props.juchuData}
          juchuListData={props.juchuListlData}
          juchuListDelData={props.juchuListDelData}
          updateJuchuListDelData={props.updateJuchuListDelData}
          juchuDetailData={props.juchuDetailData}
          dispJuchuDetailData={props.dispJuchuDetailData}
          updateJuchuDetailData={props.updateJuchuDetailData}
          updateDispJuchuDetailData={props.updateDispJuchuDetailData}
          updateJuchuListlData={props.updateJuchuListData}
          headerForm={props.headerForm}
          detailForm={props.detailForm}
          shoriSentaku={props.shoriSentaku}
          nonyuSaki={props.nonyuSaki}
          clearFlg={props.clearFlg}
          updateClearFlg={props.updateClearFlg}
          loading={props.loading}
          changeLoading={props.changeLoading}
        />
        <div style={{ marginLeft: 40, marginRight: 40 }}>
          <ExtraTableResize>
            <TableComponent
              columns={columns}
              data={props.juchuListlData}
              minHeight="33vh"
              maxHeight="33vh"
              rowIndex={rIdx}
              changeRowIndex={changeRowIndex}
              updateColumns={changeColumns}
              doubleClickCustom={doubleClick}
            />
          </ExtraTableResize>
        </div>
      </div>
    </>
  );
};
export default JuchuNyuryokuDetail;
